export const BREAKPOINT_MAX_WIDTH = 576;
export const BREAKPOINT_MIN_WIDTH = BREAKPOINT_MAX_WIDTH - 0.02;
export const HEADER_HEIGHT = 56;


export const enum FeedFilter {
  ALL = 'all',
  COMMENTS = 'comments',
  FILES = 'files',
  STATUS = 'status',
}

export enum TemplateUrls {
  CostCodePaths = '/assets/templates/cost_codes_template.csv',
  ResourcePaths = '/assets/templates/resources_template.csv',
  EstimatePaths = '/assets/templates/estimates_template.csv',
  BudgetPaths = '/assets/templates/budget_template.csv',
  CostsPaths = '/assets/templates/costs_template.csv',
}
